import { FontAwesome } from '@expo/vector-icons';
import React, { Dispatch, SetStateAction } from 'react';
import {
  View, Text, StyleSheet, Pressable, ScrollView, TouchableOpacity, TextInput,
} from 'react-native';
import Colors from '../../../../../constants/Colors';
import { userGroupName } from '../../../data';
import isMobile from '../../../../../components/IsMobile';
import Style from '../../../../../constants/Style';

interface UserGroupDropdownProps {
  userGroupDropdownShown: boolean,
  setUserGroupDropdownShown: Dispatch<SetStateAction<boolean>>,
  userGroups,
  setUserGroupSearchValue: Dispatch<SetStateAction<string>>,
  setSelectedUserGroupId: Dispatch<SetStateAction<string>>,
  userGroupSearchValue: string,
  selectedUserGroupId: string,
  closeOtherDropdowns: () => void,
}

const UserGroupDropdown = ({
  userGroupDropdownShown, setUserGroupDropdownShown, userGroups, setUserGroupSearchValue,
  setSelectedUserGroupId, userGroupSearchValue, selectedUserGroupId, closeOtherDropdowns,
}: UserGroupDropdownProps) => <View style={styles.container}>
    <View style={styles.titleContainer}>
      <Text style={styles.filterText}>{'User Group'}</Text>
    </View>
    <>
      {!userGroupDropdownShown && <TouchableOpacity
        style={[Style.dropdown, { zIndex: 2 }]}
        onPress={() => {
          setUserGroupDropdownShown(!userGroupDropdownShown);
          closeOtherDropdowns();
        }}
      >
        <View style={styles.userGroupNameContainer}>
          <>
            {selectedUserGroupId?.length > 0 ? <Text
              numberOfLines={1}
              style={[styles.chooseAssigneeText, { color: 'black', marginEnd: 26 }]}
            >
              {userGroupName(selectedUserGroupId, userGroups)}
            </Text> : <Text style={styles.chooseAssigneeText}>{'Choose User Group'}</Text>}
            <View style={{ flex: 1, alignItems: 'flex-end' }}>
              <FontAwesome
                size={20}
                style={styles.icon}
                name={'angle-down'}
              />
            </View>
          </>
        </View>
      </TouchableOpacity>}
      {userGroupDropdownShown && <View style={[Style.dropdown, { zIndex: 2 }]}>
        <TextInput
          placeholder="Search"
          style={[{ marginStart: 8 }, !isMobile && { outlineWidth: 0 }]}
          placeholderTextColor={Colors.light.hereworksPrimaryGrey700}
          onChangeText={setUserGroupSearchValue}
        />
        <TouchableOpacity
          style={{ flex: 1, alignItems: 'flex-end' }}
          onPress={() => {
            setUserGroupDropdownShown(false);
            closeOtherDropdowns();
          }}
        >
          <FontAwesome
            size={20}
            style={{ color: Colors.light.hereworksLightBlue, marginEnd: 12 }}
            name={'angle-up'}
          />
        </TouchableOpacity>
      </View>}
    </>
    {userGroupDropdownShown && <ScrollView
      style={styles.dropdownView}
      nestedScrollEnabled
    >
      <Pressable
        onPress={() => {
          setSelectedUserGroupId('');
          setUserGroupDropdownShown(false);
          closeOtherDropdowns();
        }}
        style={(state) => [
          styles.button,
          { backgroundColor: state.hovered ? Colors.light.hereworksWhite200 : undefined },
        ]}
      >
        <Text style={styles.filterText}>{'ALL USER GROUPS'}</Text>
      </Pressable>
      {userGroups.map((group: any, key) => (group.Name?.toLocaleLowerCase()
        .includes(userGroupSearchValue.toLocaleLowerCase()) ? <Pressable
          key={key}
          onPress={() => {
            setSelectedUserGroupId(group.UserGroupId);
            setUserGroupDropdownShown(false);
            closeOtherDropdowns();
          }}
          style={(state) => [
            styles.button,
            { backgroundColor: state.hovered ? Colors.light.hereworksWhite200 : undefined },
            selectedUserGroupId === group.UserGroupId && styles.selected,
          ]}
        >
        <Text style={styles.filterText}>{group.Name}</Text>
      </Pressable> : null))}
    </ScrollView>}
  </View>;

const styles = StyleSheet.create({
  container: {
    marginTop: 13,
  },
  titleContainer: {
    height: 36,
    justifyContent: 'center',
  },
  userGroupNameContainer: {
    flexDirection: 'row',
    flex: 2,
    alignItems: 'center',
  },
  chooseAssigneeText: {
    color: Colors.light.hereworksPrimaryGrey800,
    fontFamily: 'Poppins_400Regular',
    fontSize: 14,
    marginStart: 10,
  },
  dropdownView: {
    width: '100%',
    maxHeight: 200,
    backgroundColor: '#fff',
    borderWidth: 1.5,
    borderColor: Colors.light.hereworksBlue100,
    borderRadius: 10,
    marginTop: 4,
  },
  button: {
    paddingStart: 10,
    paddingVertical: 10,
    borderRadius: 4,
    marginVertical: 4,
  },
  filterText: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    lineHeight: 18,
    marginBottom: 4,
    marginEnd: 20,
    color: Colors.light.hereworksBlack600,
  },
  selected: {
    borderColor: Colors.light.hereworksBlue400,
    borderWidth: 1,
  },
  icon: {
    color: Colors.light.hereworksBlue500,
    marginEnd: 12,
  },
});

export default UserGroupDropdown;
